import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import ReconcileParamsItem from '../../../../Domain/ReconcileParamsItem';
import VExportPaymentService from '../../../../Services/VExportPaymentService';

export default class ReconcileWindowDescription {
  static titleForCreate = 'Reconcile';
  static titleForEdit = 'Reconcile';
  static finishButtonLabel = 'Reconcile';
  static itemType = ReconcileParamsItem;
  static serviceFunction = (edited) => VExportPaymentService.Reconcile(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The Reconcile process has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        { fieldName: 'ShopperName', label: 'Shopper', className: 'col-4', type: InputTypesEnum.TextReadOnly },
        { fieldName: 'ExportDate', label: 'ExportDate', className: 'col-4', type: InputTypesEnum.TextReadOnly },
        { fieldName: 'Due', label: 'Due', className: 'col-4', type: InputTypesEnum.TextReadOnly },
        {
          fieldName: 'TransactionDate',
          label: 'TransactionDate',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'TransactionMethod',
          label: 'TransactionMethod',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'TransactionReferenceNumber',
          label: 'TransactionReferenceNumber',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'TransactionFee',
          label: 'TransactionFee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'AdministrativeFee',
          label: 'AdministrativeFee',
          className: 'col-6',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
        },
        {
          fieldName: 'Reason',
          label: 'Reason',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        { fieldName: 'Notes', label: 'Notes', className: 'col-12', type: InputTypesEnum.TextBox },
      ],
    },
  ];
}
